import PropTypes from 'prop-types';
import styles from './staff.module.css';
import React, { useEffect, useState } from "react"; 
import { Typography } from "antd";    
import AddStaff from './components/add-staff/add-staff';
import CustomTextfield from '../../common/input/custom-textfield/custom-textfield';
import SVGIcon from '../../constants/SVGIcon';
import CustomFilter from '../../components/custom-filter/custom-filter';
import CustomButton from '../../common/custom-button/custom-button';
import CustomTable from '../../common/custom-table/custom-table';
import { getStaff } from '../../services/staff';

const Staff = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [filterValues, setFilterValues] = useState({
    status: [],
  });

  const filterData = [
    {
      id: "status",
      label: "Status",
      data: [],
    },
  ];

  const columns = [
    {
      title: "Reg No.",
      dataIndex: "reg_number",
      key: "reg_number",
      render: (value) => value || "-",
    },
    {
      title: "Staff Name",
      dataIndex: "staff_name",
      key: "staff_name", 
      render: (value) => value || "-",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (value) => value || "-",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (value) => value || "-",
    },
    {
      title: "Contact No.",
      dataIndex: "contact_number",
      key: "contact_number",
      render: (value) => value || "-",
    }, 
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div>
          <CustomButton
            type="text"
            icon={
              <SVGIcon
                name={"view"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#667085"}
              />
            }
            onClick={() => console.log("ok")}
          />
          <CustomButton
            type="text"
            icon={
              <SVGIcon
                name={"edit-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#667085"}
              />
            }
            onClick={() => console.log("ok")}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPageNo(1);
      getStaffList();
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, [searchTerm, filterValues]);

  const getStaffList = async (
    schoolId,
    tempPage = pageNo,
    tempPageSize = pageSize
  ) => {
    try {
      setLoading(true);
      const payload = {
        offset: (tempPage - 1) * tempPageSize,
        limit: tempPageSize,
      }; 
      const response = await getStaff();
      console.log("staff", response)
      if (response?.data) {
        setStaffList(response?.data);
        setTotalCount(response?.data?.count);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeFilter = (id, values) => {
    const tempData = { ...filterValues, [id]: values };
    setFilterValues(tempData);
  };

  const onFilterReset = () => {
    setFilterValues({
      status: [],
    });
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getStaffList(page, pageSize);
  };

  const handleAddNew = () => {
    setOpenDrawer(true);
  };

  return (
    <div className={styles.staff}>
      <div className={styles.headerContainer}>
        <Typography className={styles.title}>Staff</Typography>
        <div className={styles.filterContainer}>
          <CustomTextfield
            id={"search"}
            type={"text"}
            className={styles.inputField}
            prefix={
              <SVGIcon
                name={"search-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#667085"}
              />
            }
            placeholder={"Search"}
          />
          <CustomFilter
            filterData={filterData}
            values={filterValues}
            onResetFilter={onFilterReset}
            onChange={(id, values) => onChangeFilter(id, values)}
          />
          <CustomButton
            title="Add Staff"
            size={"large"}
            icon={
              <SVGIcon
                name={"add-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#FFF"}
              />
            }
            onClick={handleAddNew}
          />
        </div>
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={staffList}
          total={totalCount}
          loading={loading}
          showMoreIcon={true}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />

        {openDrawer && (
          <AddStaff
            open={openDrawer}
            onClose={() => {
              setOpenDrawer(false);
            }}
          />
        )}
      </div>
    </div>
  );
}; 

Staff.propTypes = {};

Staff.defaultProps = {};

export default Staff;
